<template>
    <div class="activitas-activity">
        <div class="activitas-activity__symbol flex flex-row justify-center " ref="symbol_container" v-html="currentsymbol"></div>
        <div v-if="editable" class="activitas-activity__switcher flex flex-row text-lg mt-4">
            <button class="activitas-activity__switcher__btn-explain text-grey-500 hover:text_secondary_color mx-1" @click="setSymbol('explain')" v-html="symbols.explain"></button>
            <button class="activitas-activity__switcher__btn-mime text-grey-500 hover:text_secondary_color mx-1" @click="setSymbol('mime')" v-html="symbols.mime"></button>
            <button class="activitas-activity__switcher__btn-draw text-grey-500 hover:text_secondary_color mx-1" @click="setSymbol('draw')" v-html="symbols.draw"></button>
            <button class="activitas-activity__switcher__btn-joker text-grey-500 hover:text_secondary_color mx-1" @click="setSymbol('joker')" v-html="symbols.joker"></button>
        </div>
    </div>
</template>

<script>
    import {randomSymbol} from "../../../../../resources/js/uebung-activitas/functions";

    export default {
        name: "uebung-activitas-single-card-activity-switcher",
        props: {
            editable: {
                type: Boolean,  
                default: false
            }
        },
        data: function () {
            return {
                symbols: {
                    'explain': '<i class="hi hi-lips" aria-hidden="true"></i>',
                    'mime': '<i class="fa fa-american-sign-language-interpreting" aria-hidden="true"></i>',
                    'draw': '<i class="hi hi-board-draw"></i>',
                    'joker': '<i class="fa fa-question-circle" aria-hidden="true"></i>',
                },
            }
        },
        computed: {
            currentsymbol: function () {
                return randomSymbol(this.symbols);
            }
        },
        methods: {
            setSymbol (Symbolname) {
                this.$refs.symbol_container.innerHTML = this.symbols[Symbolname];
            },
        },

    }
</script>

<style scoped>

    .activitas-activity {
        display: block;
    }

    .activitas-activity__symbol {
        font-size: 36pt;
    }


    @media print {


        .activitas-activity__switcher {
            display: none;
        }

        br {

            page-break-after: always !important;
        }
    }
</style>